import { api } from "./api";

const basePath = "/terminal";

export const getTerminalList = async ({
  pageNumber,
  limit,
  sort,
  name,
  locate,
  companyId,
}: {
  pageNumber?: number;
  limit?: number;
  sort?: string;
  locate?: string;
  name?: string;
  companyId?: string;
}) => {
  try {
    const params: Record<string, any> = {};
    if (pageNumber !== undefined) params.pageNumber = pageNumber;
    if (limit !== undefined) params.limit = limit;
    if (sort !== undefined) params.sort = sort;
    if (name !== undefined) params.name = name;
    if (locate !== undefined) params.locate = locate;
    if (companyId !== undefined) params.companyId = companyId;

    const res = await api.get(`${basePath}/list`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const getLocateList = async ({ companyId }: { companyId?: string }) => {
  try {
    const params: Record<string, any> = {};
    if (companyId !== undefined) params.companyId = companyId;

    const res = await api.get(`${basePath}/locate`, { params });
    return res;
  } catch (error) {
    return error;
  }
};
